import useMobile from "../../hooks/useMobile"

const PageHeaderWrapper = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useMobile()

  return (
    <div
      className={`pt-3 pb-2 w-full flex flex-row items-center justify-between max-w-[600px] mx-auto sticky top-0  z-20 ${
        isMobile ? "bg-white" : "bg-bgXLightGray"
      }`}
    >
      {children}
    </div>
  )
}

export default PageHeaderWrapper
